module.exports = __webpack_public_path__ + "static/media/arthur.mariet.2a7fb1d9.jpg";